


















import mobile from 'is-mobile'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class extends Vue {
  get isMobile () {
    return mobile()
  }

  onClickCarouselScroll (isForward: boolean) {
    const ele = (this.$refs.main as HTMLElement).firstElementChild as HTMLElement
    ele.scrollLeft += ele.clientWidth * (isForward ? 1 : -1) * 0.51
  }
}
